import Road from './Road'
import color from './colorThemes'
import config from '../../../config'

const { minZoom, maxZoom } = config.map
const start = minZoom + 1

export default {
  ...Road,
  id: 'roadMinor',
  minzoom: start,
  filter: [
    ...Road.filter,
    ['in', 'type', 'residential', 'unclassified', 'living_street'],
  ],
  paint: {
    'line-color': color.roadMinor,
    'line-width': {
      stops: [[start, 0.25], [maxZoom, 5]],
    },
    'line-opacity': {
      stops: [[start, 0], [start + 1, 1]],
    },
  },
}
